import React, { Component } from 'react'
import { Icon } from 'antd'
import { Audio, Stream } from './components'
import { builder } from '../../../constants'
import './Preview.scss'
import { useTranslation } from 'react-i18next'
import { customContentClass } from './Preview.ctrl'
// import annotationIcon from '../../../assets/annotation_icon.png'
// import { marginLeft } from 'styled-system'

const { types, icons } = builder

const Placeholder = ({ type }) => {
  const { t } = useTranslation()
  return (
    <div className="el-placeholder">
      <div className="el-placeholder__icon">
        <Icon type={icons[type]} />
      </div>
      <div className="el-placeholder__text">
        {types[type] &&
          types[type].toLowerCase() +
          ` ${t('general:component').toLowerCase()}`}
      </div>
    </div>
  )
}

const TextPreview = props => {
  const {
    node: { params },
    scale = 1
  } = props

  const processContent = (htmlContent, scale) => {
    if (!htmlContent) return ''

    // First apply scaling to any existing font-size styles
    let processedContent = htmlContent.replace(
      /font-size:\s*(\d+(\.\d+)?)px/gi,
      (match, size) => {
        const scaledSize = parseFloat(size) * scale
        return `font-size: ${scaledSize}px`
      }
    )

    // Next, add a default font-size to text elements that don't have one
    if (scale !== 1) {
      // Only apply this when scaling is needed (not at normal size)
      // Parse the HTML using DOMParser
      const parser = new DOMParser()
      const doc = parser.parseFromString(processedContent, 'text/html')

      // Handle text nodes and elements without font-size
      const addDefaultFontSize = element => {
        // Skip elements that already have font-size style
        if (element.style && element.style.fontSize) {
          return
        }

        // Check if any parent already has font-size defined
        let parent = element.parentElement
        let hasFontSize = false
        while (parent && parent.tagName !== 'BODY') {
          if (parent.style && parent.style.fontSize) {
            hasFontSize = true
            break
          }
          parent = parent.parentElement
        }

        // If no parent has font-size, add the default scaled font-size
        if (
          !hasFontSize &&
          element.nodeType === 1 &&
          !['SCRIPT', 'STYLE', 'BR'].includes(element.tagName)
        ) {
          // Don't add font-size to elements that shouldn't have it
          if (element.textContent.trim().length > 0) {
            const defaultSize = 14 * scale
            element.style.fontSize = `${defaultSize}px`
          }
        }

        // Process child nodes recursively
        Array.from(element.childNodes).forEach(child => {
          if (child.nodeType === 1) {
            // Element node
            addDefaultFontSize(child)
          }
        })
      }

      // Process the root element's children
      Array.from(doc.body.children).forEach(child => {
        addDefaultFontSize(child)
      })

      // If there's any text directly in the body, wrap it in a paragraph with the default font size
      const textNodes = Array.from(doc.body.childNodes).filter(
        node => node.nodeType === 3 && node.textContent.trim().length > 0
      )

      textNodes.forEach(textNode => {
        const p = doc.createElement('p')
        p.style.fontSize = `${14 * scale}px`
        p.textContent = textNode.textContent
        textNode.parentNode.replaceChild(p, textNode)
      })

      // Get the processed HTML
      processedContent = doc.body.innerHTML
    }

    // Handle Markdown-style formatting
    return processedContent
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // **bold** → <strong>
      .replace(/\*(.*?)\*/g, '<em>$1</em>') // *italic* → <em>
  }

  const processedContent = processContent(params.content, scale)
  return (
    <div className="preview">
      <div
        className="ql-editor preview-content"
        dangerouslySetInnerHTML={{ __html: processedContent }}
      />
    </div>
  )
}

const ImagePreview = props => {
  const {
    node: { params }
  } = props
  return (
    <div
      className="preview preview_image"
      style={{
        backgroundSize: 'cover',
        backgroundImage: 'url(' + params.content + ')',
        borderRadius: '10px'
      }}
    />
  )
}

const VideoPreview = props => {
  const { node: { params } } = props;
  const isVimeo = params.content.includes('vimeo');

  // Extract Vimeo video ID from URL
  const getVimeoId = (url) => {
    const match = url.match(/\/video\/(\d+)/);
    return match ? match[1] : null;
  };

  const wrapperStyle = {
    width: '100%',
    height: '100%',
    //paddingBottom: '56.25%', // 16:9 aspect ratio
    position: 'relative',
    overflow: 'hidden'
  };

  const contentStyle = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    border: 'none'
  };

  if (isVimeo) {
    const videoId = getVimeoId(params.content);
    // Using Vimeo's optimized player parameters
    const optimizedVimeoUrl = `https://player.vimeo.com/video/${videoId}?color=0068FF&title=0&byline=0&portrait=0&dnt=1&quality=auto`;

    return (
      <div className="video-preview" style={wrapperStyle}>
        <iframe
          title="Sharelook Video Player"
          src={optimizedVimeoUrl}
          style={contentStyle}
          //allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
    );
  } else {
    // For non-Vimeo videos (assuming direct video URLs)
    return (
      <div className="video-preview" style={wrapperStyle}>
        <video
          className="video-preview__media"
          controls
          style={contentStyle}
          src={params.content}
          preload="metadata"
        />
      </div>
    );
  }
};

const AnnotationPreview = props => {
  const {
    node: { params }
  } = props
  const { t } = useTranslation()
  return (
    <div className="preview preview_annotation">
      {/* {t('labels:id_annotation')}: {params.content} */}
      {params.content}
    </div>
  )
}
// const AnnotationPreview = props => {
//   const {
//     node: {
//       params: { height, width }
//     }
//   } = props
//   return (
//     <div className="preview preview_annotation">
//       <img
//         src={annotationIcon}
//         alt="annotation icon"
//         style={{
//           height: height,
//           width: width,
//           objectFit: 'contain',
//           borderRadius: '50%',
//           boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
//           cursor: 'pointer',
//           border: '2px solid #ddd'
//         }}
//       />
//     </div>
//   )
// }

const BackgroundPreview = props => {
  const {
    node: { params }
  } = props

  const backgroundOpacity = params.opacity || 1

  if (props.node.type === types.BACKGROUND_COLOR) {
    return (
      <div
        className="preview preview_background"
        style={{
          backgroundColor: params.content
        }}
      />
    )
  }

  if (props.node.type === 'BACKGROUND_IMAGE') {
    return (
      <div
        className="preview preview_background bg-img"
        style={{
          backgroundImage: 'url(' + params.content + ')',
          opacity: backgroundOpacity
        }}
      />
    )
  }
  if (
    props.node.type === 'BACKGROUND_IMAGE_AUTO' &&
    props.node.auto &&
    params.content !== null
  ) {
    return (
      <div
        className="preview preview_background bg-img"
        style={{
          backgroundImage: 'url(' + params.content + ')',
          opacity: backgroundOpacity
        }}
      />
    )
  }
  return (
    <div
      className="preview preview_background bg-img"
      style={{
        backgroundImage: ''
      }}
    />
  )
}

const QuizPreview = props => {
  const {
    node: { params }
  } = props
  const { t } = useTranslation()

  return (
    <div className="preview preview_annotation">
      {params.isSimulation ? 'SimulationID' : t('labels:id_quiz')}:{' '}
      {params.content}
    </div>
  )
}

const ScenarioPreview = props => {
  const {
    node: { params }
  } = props

  return (
    <div className="preview preview_annotation">
      ScenarioID: {params.content}
    </div>
  )
}

export default class Preview extends Component {
  render() {
    const {
      node,
      node: { params },
      isView,
      elementHeight,
      elementWidth,
      scale,
      autoPlay = false
    } = this.props

    const isLogoElement =
      node.type === types.IMAGE && node.display && node.display === 'LOGO'

    if (
      params &&
      !params.content &&
      node.type !== types.BACKGROUND_IMAGE &&
      node.type !== types.BACKGROUND_COLOR &&
      node.type !== types.BACKGROUND_IMAGE_AUTO
    ) {
      return (
        <div className={customContentClass(node.type === types.TEXT)}>
          <Placeholder type={isLogoElement ? types.LOGO : node.type} />
        </div>
      )
    }

    if (isLogoElement) {
      return null
    }

    console.log('node', node)

    return (
      <div className={customContentClass(node.type === types.TEXT, isView)}>
        {node.type === types.TEXT && <TextPreview node={node} scale={scale} />}
        {node.type === types.IMAGE && <ImagePreview node={node} />}
        {node.type === types.ARIMAGE && <ImagePreview node={node} />}
        {node.type === types.VIDEO && <VideoPreview node={node} />}
        {node.type === types.AUDIO && (
          <Audio
            elementHeight={elementHeight}
            elementWidth={elementWidth}
            node={node}
            autoPlay={autoPlay}
          />
        )}
        {node.type === types.ANNOTATION && <AnnotationPreview node={node} />}
        {(node.type === types.BACKGROUND_IMAGE ||
          node.type === types.BACKGROUND_COLOR ||
          node.type === types.BACKGROUND_IMAGE_AUTO) && (
            <BackgroundPreview node={node} />
          )}
        {node.type === types.QUIZ && <QuizPreview node={node} />}
        {node.type === types.VIDEO_STREAM && <Stream node={node} />}
        {node.type === types.SCENARIO && <ScenarioPreview node={node} />}
      </div>
    )
  }
}
